import { useMemo } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import { buildWorkspacePath, parseNavigationStack } from "../../core";
import type { NavigationStack } from "../../core";

// Reads the live URL (orgCode + drill splat) into a typed NavigationStack, and
// gives a typed way to navigate to a new stack. The URL stays the single source
// of navigation truth (routing.md).
export function useWorkspaceNavigation() {
    const navigate = useNavigate();
    const params = useParams({ strict: false }) as { orgCode?: string; _splat?: string };
    const orgCode = params.orgCode ?? "";
    const splat = params._splat ?? "";

    const stack = useMemo<NavigationStack>(
        () => parseNavigationStack(splat.split("/").filter(Boolean)),
        [splat],
    );

    const navigateTo = (path: string) => navigate({ to: path } as Parameters<typeof navigate>[0]);
    const goToStack = (next: NavigationStack) => navigateTo(buildWorkspacePath(orgCode, next));

    return { orgCode, stack, navigate, navigateTo, goToStack };
}
